import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('../views/index/index.vue')
  },
  {
    path: '/companyIntro',
    name: 'CompanyIntro',
    component: () => import('../views/companyIntro/index.vue')
  },
  {
    path: '/trading',
    name: 'Trading',
    component: () => import('../views/solution/trading.vue')
  },
  {
    path: '/industryStatus',
    name: 'IndustryStatus',
    component: () => import('../views/solution/industryStatus.vue')
  },
  {
    path: '/becomePartner',
    name: 'BecomePartner',
    component: () => import('../views/partner/becomePartner.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
